/* istanbul ignore file */
import React from 'react';
import './ContactInfo.css';

const ContactInfo = () => (
    <section className="section contact-info">
        <div className="container">
            <div className="columns">
                <div className="column">
                    <div className="contact-item los-angeles">
                        <div className="contact-header">
                            LOS ANGELES
                        </div>
                        <div className="contact-details">
                            <p>
                                <a href="https://maps.app.goo.gl/eNDQ8DdogxvDodys8" className='conctact-address' target="_blank">
                                    11601 WILSHIRE BLVD<br/>
                                    9TH FLOOR<br/>
                                    LOS ANGELES, CA 90025
                                </a>
                            </p>
                            <p className="phone"><a href="tel:(310) 445-5700">(310) 445-5700</a></p>
                        </div>
                    </div>

                    <div className="columns is-multiline other-locations">
                        <div className="column is-6-tablet is-6-desktop">
                            <div className="contact-item">
                                <div className="contact-header">
                                    SAN FRANCISCO
                                </div>
                                <div className="contact-details">
                                    <p>
                                        <a href="https://maps.app.goo.gl/J27VXsANygDp1cJ5A" className='conctact-address' target="_blank">
                                            121 SPEAR ST<br/>
                                            SUITE 220<br/>
                                            SAN FRANCISCO, CA 94105
                                        </a>
                                    </p>
                                    <p className="phone"><a href="tel:(415) 777-4100">(415) 777-4100</a></p>
                                </div>
                            </div>
                        </div>
                        <div className="column is-6-tablet is-6-desktop">
                            <div className="contact-item">
                                <div className="contact-header">
                                    SILICON VALLEY
                                </div>
                                <div className="contact-details">
                                    <p>
                                         <a href="https://maps.app.goo.gl/79uPeRNU9zizEWFY9" className='conctact-address' target="_blank">
                                            333 TWIN DOLPHIN DRIVE<br/>
                                            SUITE 100<br/>
                                            REDWOOD CITY, CA 94065
                                         </a>
                                    </p>
                                    <p className="phone"><a href="tel:(650) 200-2900">(650) 200-2900</a></p>
                                </div>
                            </div>
                        </div>
                        <div className="column is-6-tablet is-6-desktop">
                            <div className="contact-item">
                                <div className="contact-header">
                                    SEATTLE
                                </div>
                                <div className="contact-details">
                                    <p>
                                        <a href="https://maps.app.goo.gl/cb6ZccqyZnoRuVtk8" className='conctact-address' target="_blank">
                                            411 FIRST AVE. SOUTH<br/>
                                            SUITE 300N<br/>
                                            SEATTLE, WA 98104
                                        </a>
                                    </p>
                                    <p className="phone"><a href="tel:(206) 462-1895">(206) 462-1895</a></p>
                                </div>
                            </div>
                        </div>
                        <div className="column is-6-tablet is-6-desktop">
                            <div className="contact-item">
                                <div className="contact-header">
                                    VANCOUVER
                                </div>
                                <div className="contact-details">
                                    <p>
                                        <a href="https://maps.app.goo.gl/pNZWLUwJuuf5CYxS8" className='conctact-address' target="_blank">
                                            3110 – 1055 DUNSMUIR STREET<br/>
                                            VANCOUVER<br/>
                                            BC V7X 1L3
                                        </a>
                                    </p>
                                    <p className="phone"><a href="tel:(778) 328-5960">(778) 328-5960</a></p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="contact-social">
                        <div className="social-title">FOLLOW US</div>
                        <div className="social-subtitle">
                            Connect with us to stay up to date
                            with the latest from
                            Hudson Pacific Properties.
                        </div>
                        <div className="social-icons">
                            <a className="social-icon facebook" target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/HudsonPPI/">
                                <div aria-label="Facebook"></div>
                            </a>
                            <a className="social-icon instagram" target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/hudsonppi/">
                                <div aria-label="Instagram"></div>
                            </a>
                            {/* <a className="social-icon twitter" target="_blank" rel="noopener noreferrer" href="https://twitter.com/HudsonPPI">
                                <div aria-label="Twitter"></div>
                            </a> */}
                            <a className="social-icon linkedin" target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/company/hudson-pacific-properties-inc-?">
                                <div aria-label="LinkedIn"></div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
);

export default ContactInfo;
